// Dodawanie wpisów: okno „Nowy wpis", pola typów, menu „+" i dyktowanie (AI).
export default {
    types: {
        meal: { label: 'Meal', title: 'New meal', editTitle: 'Edit meal' },
        sleep: { label: 'Sleep', title: 'New sleep entry', editTitle: 'Edit sleep' },
        task: { label: 'Task', title: 'New task', editTitle: 'Edit task' },
        event: { label: 'Event', title: 'New event', editTitle: 'Edit event' },
        note: { label: 'Note', title: 'New note', editTitle: 'Edit note' },
        report: { label: 'Day entry', title: 'New day entry', editTitle: 'Edit day entry' },
        workout: { label: 'Workout', title: 'New workout', editTitle: 'Edit workout' },
    },
    validation: {
        nameRequired: 'Name is required',
        timeRequired: 'Time is required',
        workoutTypeRequired: 'Choose a workout type',
        doneWorkoutDuration: 'A completed workout needs a duration',
        doneWorkoutCalories: 'A completed workout needs calories',
        sleepTimeRequired: 'Enter a bedtime or wake-up time',
        qualityRange: 'Quality is a number from 1 to 100',
        napTimes: 'Each nap needs a start and end time',
        taskTextRequired: 'Task text is required',
        taskTimeRequired: 'Enter a time or turn the time off',
        weekdayRequired: 'Choose at least one day of the week',
        recurringNeedsDay: 'A recurring task needs a day to start from',
        noteContentRequired: 'Enter some text or a title',
        eventTitleRequired: 'Event name is required',
        endBeforeStart: 'The end can’t be before the start',
        startTimeRequired: 'Enter a start time',
        endTimeRequired: 'Enter an end time',
        reportContentRequired: 'Enter the entry text',
    },
    dialog: {
        close: 'Close',
        delete: 'Delete',
        cancel: 'Cancel',
        saving: 'Saving…',
        save: 'Save',
        saveChanges: 'Save changes',
        checkData: 'Check the details you entered.',
        tasksUnsupported: 'This API doesn’t support tasks yet.',
        saveFailed: 'Couldn’t save. Please try again.',
        deleteFailed: 'Couldn’t delete the entry.',
        deleteTitle: 'Delete this entry ({type})?',
        deleteLinkedEventMessage: 'The event will disappear from the day timeline and from Google Calendar (if sync is on). This can’t be undone.',
        deleteMessage: 'The entry will disappear from the day timeline. This can’t be undone.',
    },
    fab: {
        menuHeading: 'ADD TO {day}',
        addTo: 'Add to {day}',
        close: 'Close',
        typeSentence: 'Type a sentence…',
        shortcuts: { meal: 'M', sleep: 'S', task: 'T', event: 'E', note: 'N', workout: 'W', report: 'D' },
    },
    fields: {
        time: 'Time',
    },
    daySelect: {
        label: 'Day',
        today: 'today',
        yesterday: 'yesterday',
        tomorrow: 'tomorrow',
        search: 'Search for a day…',
    },
    when: {
        optional: '— optional',
        setTime: 'Set a time',
        past: 'past',
        noTime: 'No time',
    },
    event: {
        pinnedPlaces: 'Pinned',
        otherPlaces: 'Others',
        myPlaces: 'My places',
        titlePlaceholder: 'What’s happening? e.g. Hairdresser',
        allDay: 'All day',
        firstDay: 'First day',
        start: 'Start',
        lastDay: 'Last day',
        end: 'End',
        location: 'Place',
        locationPlaceholder: 'Address, name or Google Maps link — optional',
        pickPlace: 'Choose from saved places',
        searchPlace: 'Search places…',
        description: 'Description',
        descriptionPlaceholder: 'Details — optional',
        recurringInfo: 'This is one occurrence of a Google Calendar series — changes and deletion apply to this day only.',
        linkedPending: 'Linked to Google Calendar — the change is waiting to be sent.',
        linked: 'Linked to Google Calendar.',
    },
    ingredients: {
        heading: 'INGREDIENTS',
        nameRequired: 'Enter the ingredient name.',
        weightPositive: 'Weight must be greater than zero.',
        codeNotFound: 'Code {code} isn’t in Open Food Facts — enter the product manually.',
        codeCheckFailed: 'Couldn’t check the code. Please try again.',
        weightOf: 'Weight of ingredient {name}',
        remove: 'Remove {name}',
        empty: 'No ingredients yet — add the first one below.',
        ingredient: 'Ingredient',
        searchPlaceholder: 'Search the catalogue or type your own name',
        amount: 'Amount',
        scan: 'Scan the product barcode',
        add: 'Add',
        checkingCode: 'Checking the code…',
        hint: 'A catalogue product brings its own macros; a name outside the catalogue adds an item without values.',
        total: 'Total {kcal} kcal · {grams} g',
    },
    meal: {
        nutrients: {
            calories: 'Calories',
            protein: 'Protein',
            carbs: 'Carbs',
            fat: 'Fat',
            saturated_fat: 'Saturated',
            sugar: 'Sugars',
            fiber: 'Fibre',
            salt: 'Salt',
        },
        fromSaved: 'From saved meals',
        manualEntry: 'I’ll enter it manually',
        searchMeal: 'Search meals…',
        singleProduct: 'Or a single product',
        searchProduct: 'Search products',
        weightGrams: 'Weight g',
        namePlaceholder: 'What are you eating? e.g. porridge with blueberries',
        status: 'Status',
        eaten: 'Eaten',
        planned: 'Planned',
        editIngredients: 'Edit meal ingredients',
        addIngredients: 'Add meal ingredients',
        valuesFromIngredients: 'VALUES FROM INGREDIENTS',
        nutritionValues: 'NUTRITION VALUES',
        enterMacrosManually: 'Enter macros manually',
        price: 'Price',
        computedHint: 'Calculated from the ingredients — the API will recalculate them after saving.',
    },
    naps: {
        heading: 'NAPS',
        total: 'Total {total}',
        startOf: 'Start of nap {n}',
        endOf: 'End of nap {n}',
        qualityPlaceholder: 'quality',
        qualityOf: 'Quality of nap {n}',
        notePlaceholder: 'note',
        noteOf: 'Note for nap {n}',
        remove: 'Remove nap {n}',
        empty: 'No naps this day.',
        add: 'Add a nap',
    },
    note: {
        titlePlaceholder: 'Title — optional',
        contentPlaceholder: 'What do you want to remember?',
    },
    report: {
        contentPlaceholder: 'What just happened?',
    },
    sleep: {
        wakeDay: 'Wake-up day',
        bedtime: 'Fell asleep',
        bedtimePlaceholder: 'e.g. 23',
        wakeUp: 'Woke up',
        wakeUpPlaceholder: 'e.g. 7',
        noWakeUp: 'Without a wake-up time the entry stays unfinished — add it in the morning.',
        noBedtime: 'Without a bedtime the entry stays unfinished.',
        quality: 'Quality',
        notes: 'Notes',
        notesPlaceholder: {
            male: 'How did you sleep? What disturbed you?',
            female: 'How did you sleep? What disturbed you?',
        },
    },
    task: {
        textPlaceholder: 'What needs doing?',
        noDayInfo: 'No day — the task waits in “To schedule” until you give it a day.',
        noDayToggle: 'Not sure when yet — to schedule',
        reminder: 'Reminder',
        repeat: 'Repeat',
        weekdays: 'Days of the week',
        every: 'every',
        interval: 'How often',
        intervalUnit: {
            daily: 'day | days',
            weekly: 'week | weeks',
            monthly: 'month | months',
        },
        repeatSummary: '{summary} — it stays ticked off on that day and the task moves on to the next one.',
        project: 'Project',
        untitledProject: 'Untitled project',
        noProject: 'No project — standalone task',
        searchProject: 'Search projects…',
    },
    workout: {
        fallbackName: 'Workout',
        repeat: 'Repeat a workout',
        fromScratch: 'I’ll enter it from scratch',
        searchWorkout: 'Search workouts…',
        type: 'Workout type',
        pickType: 'Choose a type',
        searchType: 'Search types…',
        noTypes: 'You don’t have any workout types yet — add them in Workouts → Workout types.',
        start: 'Start',
        status: 'Status',
        done: 'Done',
        planned: 'Planned',
        plannedHint: 'You’ll fill in the time and calories once the workout happens.',
        duration: 'Duration',
        hoursUnit: 'hrs',
        minutesUnit: 'min',
        calories: 'Calories',
        distance: 'Distance',
    },
    voice: {
        errors: {
            silence: 'I can’t hear anything — check which microphone the browser has chosen.',
            noAccess: 'No microphone access — allow it in your browser.',
            noMic: 'The browser can’t see a microphone — check which one is selected.',
            micBusy: 'The microphone is being used by another app.',
            network: 'Speech recognition needs an internet connection.',
            micError: 'Microphone error ({code}).',
            noSpeech: 'No speech was recognised in the recording — try again.',
            recordingInvalid: 'The recording is empty or too long.',
            transcribeService: 'Speech recognition service error — please try again.',
            transcribeNotConfigured: 'Speech recognition isn’t configured.',
            recordingSendFailed: 'Couldn’t send the recording.',
            notRecognized: 'Couldn’t recognise what the entry is.',
            emptyEntry: 'The entry is empty.',
            aiService: 'AI service error — please try again.',
            aiNotConfigured: 'The AI service isn’t configured.',
            sendFailed: 'Couldn’t send the entry.',
        },
        day: {
            today: 'today',
            tomorrow: 'tomorrow',
            yesterday: 'yesterday',
        },
        card: {
            failed: 'Didn’t work',
            taskAdded: 'Task added',
            eventAdded: 'Event added',
            allDayOn: '{day}, all day',
            bedtimeSaved: 'Bedtime saved',
            wakeUpSaved: 'Wake-up saved',
            sleepSaved: 'Sleep saved',
            bedtimeAt: 'fell asleep {time}',
            wakeUpAt: 'woke up {time}',
            quality: 'quality {quality}',
            noteSaved: 'Note saved',
            reportSaved: 'Day report saved',
            workoutToCheck: 'Workout to check',
            fillDetails: 'Fill in the details in the form',
            mealToCheck: 'Meal to check',
            shoppingToCheck: 'Groceries to check: {n} item | Groceries to check: {n} items',
            shoppingNothing: 'Nothing to buy was recognised',
            entrySaved: 'Entry saved',
            mealAdded: 'Meal added',
            workoutAdded: 'Workout added',
            increased: '{n} added to items already on the list',
            newProducts: 'new products: {list}',
            shoppingAdded: 'Added to groceries: {n} item | Added to groceries: {n} items',
            shoppingSkipped: 'Groceries skipped',
            corrected: 'Updated',
            deleted: 'Deleted',
            undone: 'Undone: {what}',
            what: {
                task: 'task',
                event: 'event',
                note: 'note',
                daily: 'day report',
            },
            undoFailed: 'Couldn’t undo',
        },
        sections: {
            saved: 'Saved',
            pending: 'To confirm',
            failed: 'Didn’t work',
            other: 'Undone and skipped',
        },
        eyebrow: {
            welcome: 'Welcome to Rountine',
            shopping: 'Grocery dictation',
            dictation: 'Dictation',
        },
        heading: {
            reviewShopping: 'Check groceries',
            welcomeDone: 'Your day is taking shape',
            results: 'What happened',
            welcome: 'What are your plans for today?',
            shopping: 'Say what to buy',
            add: 'Say what to add',
        },
        actions: {
            retry: 'Send this part again',
            review: 'Check',
            correct: 'Correct',
            edit: 'Edit',
            undo: 'Undo',
        },
        links: {
            basket: 'Groceries',
            shoppingList: 'Shopping list',
            notes: 'Notes',
            planner: 'View in Planner',
        },
        welcomeIntro: 'Say or type several things at once — meetings, tasks, a workout, groceries. The assistant will split them into entries and lay them out in the Planner, and you can correct or undo each one.',
        welcomeExample: 'Workout at 6 pm today, dinner with Ola at 8, call Mum and buy milk',
        textPlaceholder: 'The recognised text will appear here — you can correct it…',
        textPlaceholderManual: 'Type the text manually…',
        exampleHint: 'For example — click to insert',
        quoted: '“{text}”',
        basketSubtitle: 'From dictation — untick what you do not need.',
        shoppingHint: 'e.g. “Milk, two kilos of potatoes, pesto for four servings, ingredients for ratatouille and bin bags”. You’ll see a preview before anything is added.',
        whatYouCanRecord: 'What you can record',
        saveAuto: 'Saves straight away.',
        saveConfirm: 'A form opens so you can check it before saving.',
        examplesHint: 'Examples — click to insert',
        whatYouCanSay: 'What you can say',
        defaultValue: '(default: {value})',
        hideDetails: 'Hide details',
        details: 'Details',
        multiHint: 'You can say several things in one recording, e.g. two events and some groceries. Times (“yesterday”, “at 7”) count from now.',
        plannedHint: 'Coming soon: {list} — for now such a recording goes to the day report.',
        fallbackHint: 'e.g. “I had porridge with banana for breakfast” or “I ran 5 km in 28 minutes”.',
        recordAnother: 'Record another',
        done: 'Done',
        recording: 'Recording {time}',
        status: {
            transcribing: 'Recognising the recording…',
            listening: 'Listening… speak',
            serverPhone: 'Tap, speak and tap stop',
            server: 'Click, speak and click stop',
            browserPhone: 'Tap and speak',
            browser: 'Click and speak',
            unavailable: 'Recording unavailable — type the text',
        },
        maxLength: 'Max {min} min — the recording will stop by itself.',
        addManually: 'I’ll add it manually',
        cancel: 'Cancel',
        stop: 'Stop',
        stopRecording: 'Stop recording',
        record: 'Record',
        send: 'Send',
    },
};
